import * as z from 'zod';

const ReviewEditSchema = z.object({
  published: z.string().min(1, { message: 'Required' }),
  rating: z.number().min(1).max(5),
  title: z.string().min(1, { message: 'Required' }),
  mainReview: z.string(),
  bestParts: z.string(),
  doDifferently: z.string(),
  agentReply: z.string().optional(),
});

export default ReviewEditSchema;
